import React from 'react';
import { InstanceIdContext } from './InstanceIdContext';

export const InstanceIdProvider: React.FC<{
  children: React.ReactNode;
  instanceId: string;
}> = ({ children, instanceId }) => {
  return (
    <InstanceIdContext.Provider value={{ instanceId }}>
      {children}
    </InstanceIdContext.Provider>
  );
};